import { render, staticRenderFns } from "./indicadores-ver.vue?vue&type=template&id=38d3f9f6&scoped=true&"
import script from "./indicadores-ver.vue?vue&type=script&lang=js&"
export * from "./indicadores-ver.vue?vue&type=script&lang=js&"
import style0 from "./indicadores-ver.vue?vue&type=style&index=0&id=38d3f9f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d3f9f6",
  null
  
)

export default component.exports